import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-returnPie",
  "use": "icon-returnPie-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\" id=\"icon-returnPie\">\r\n<path d=\"M96.3,57.5h31.4C124.8,27.3,100.4,3,70.3,0.1v31.4C83.4,34.1,93.7,44.3,96.3,57.5z\" />\r\n<path d=\"M57.5,31.5V0.1C27.3,3,3,27.3,0.1,57.5h31.4C34.1,44.3,44.3,34.1,57.5,31.5z\" />\r\n<path d=\"M31.5,70.3H0.1C3,100.7,27.3,124.8,57.8,128V96.6C44.3,93.7,34.1,83.4,31.5,70.3z\" />\r\n<path d=\"M93.5,127.6c12.9-6.6,16.8-18.3,13.4-29.1c-2.6-8.1-9.7-12.3-18.6-14.3c-4.5-1.1-8.9-1.1-13.4-1.3c-1.6,0-2.1,0.2-2.1,1.8\r\n\tv12.7c0,0.8-1.1,1.2-1.7,0.6c-6.6-5.4-29.8-24.7-29.7-24.8c-0.5-0.4-1.8-1.1-0.5-2.2c9.9-8.3,20.1-16.7,30.2-25.2\r\n\tc0.7-0.5,1.8-0.2,1.8,0.6v9.4c0,1.8,0.3,2.4,2.9,2.4c8.4,0.2,16.5,1.3,24.4,4.2c14.9,5.5,22,15.4,22.8,28.8\r\n\tc1,15.9-10,30.6-26.5,36.1c-0.3,0-0.5,0.2-1,0.2C94,128,93.5,128.2,93.5,127.6L93.5,127.6z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/returnPie.svg
// module id = hCSM
// module chunks = 164